// extracted by mini-css-extract-plugin
export var resizer = "_hj-0";